import styled from "styled-components";

export const AlfredoCentralButton = styled.button`
  position: fixed;
  width: 7%;
  background-color: transparent;
  border: none;
  z-index: 10;
  cursor: pointer;
  border-radius: 70%;
  &:hover {
    box-shadow: 0 0 100px ${({ theme }) => theme.colors.selection};
    transform: scale(1.05);
    transition: all 0.5s ease-in-out;
  }
  transition: box-shadow 0.5s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
`;
